import DataGridTableSkeleton from "../../../components/skeletons/DataGridTableSkeleton";

export default function PartnersListSkeleton() {
  return (
    <DataGridTableSkeleton height={500} rowCount={10} />
  );
}
